import Icon from './Icon';

const ShareOutline = (props) => (
  <Icon
    width="20px"
    height="16px"
    size="20px"
    viewBox="0 0 20 16"
    strokeWidth="1.5"
    stroke="#A2A0A2"
    color="none"
    {...props}
    path="M8.73472 4.45811C4.66136 4.91782 1.58221 8.36222 1.58008 12.4614V12.9717C3.35039 10.839 5.96346 9.58549 8.73472 9.53939V12.2297C8.73482 12.62 8.95794 12.976 9.30922 13.1462C9.66049 13.3164 10.0781 13.271 10.3846 13.0292L17.0457 7.76949C17.2822 7.58311 17.4202 7.29861 17.4202 6.9975C17.4202 6.69639 17.2822 6.41189 17.0457 6.22551L10.3846 0.965822C10.0781 0.724011 9.66049 0.678552 9.30922 0.848776C8.95794 1.019 8.73482 1.37497 8.73472 1.76532V4.45811Z"
  />
);

export default ShareOutline;
